import AirbrakeClient from 'airbrake-js'

export let airbrake = new AirbrakeClient({
  projectId: process.env.AIRBRAKE_PROJECT_ID,
  projectKey: process.env.AIRBRAKE_PROJECT_KEY
})

airbrake.addFilter(notice => {
  if (process.env.NODE_ENV === 'dev') return null
  return notice
})

export function airbrakeNotify(text) {
  airbrake.notify({
    error: text,
    context: { site_id: JENSEN_SITE_ID }
  })
}



// WEBPACK FOOTER //
// ./app/common/airbrake.js